import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=5f3c6e2c&scoped=true&"
import script from "./Reactions.vue?vue&type=script&lang=js&"
export * from "./Reactions.vue?vue&type=script&lang=js&"
import style0 from "./Reactions.vue?vue&type=style&index=0&id=5f3c6e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c6e2c",
  null
  
)

export default component.exports